import React from "react";
import Nav from "./Components/Nav";
import CHHomeBody from "./Components/BodyHome";
import Footer from "./Components/Footer";

class CHHome extends React.Component {
    render() {
        return (<>
            <Nav />
            <CHHomeBody />
            <Footer />
        </>
        );
    }
}

export default CHHome;